import { useI18n } from "vue-i18n";
import { userApi } from "@wkt/api/user/userAPI";
import { useAlert } from "@wkt/composables/useAlert";
import { useKeycloak } from "@wkt/composables/useKeycloak";
import { useAppDialogsStore } from "@wkt/stores/appDialogs";

const CLIENT_MODULE = "CLIENT";

export function useGlobalDialogActions() {
  const { t } = useI18n();
  const { showAlert } = useAlert();
  const { logout } = useKeycloak();
  const appDialogsStore = useAppDialogsStore();

  function openIncidenceDialog(): void {
    appDialogsStore.openIncidence();
  }

  function openLogoutDialog(): void {
    appDialogsStore.openLogout();
  }

  async function confirmLogout(): Promise<void> {
    appDialogsStore.closeLogout();
    const redirectUrl = window.location.origin + window.location.pathname;
    await logout(redirectUrl);
  }

  async function openFeatureMessagesDialog(): Promise<void> {
    try {
      const messages = await new Promise((resolve, reject) => {
        userApi.getFeatureMessages(CLIENT_MODULE, resolve, reject);
      });

      if (!Array.isArray(messages) || messages.length === 0) {
        showAlert({
          text: t("wkt.client.application.show-tutorial-no-data"),
          color: "info",
        });
        return;
      }

      appDialogsStore.openFeatureMessages(messages);
    } catch (_) {
      showAlert({
        text: t("wkt.client.application.show-tutorial-error"),
        color: "error",
      });
    }
  }

  async function openAcceptedTermsDialog(): Promise<void> {
    try {
      const terms = await new Promise((resolve, reject) => {
        userApi.getAcceptedTerms(resolve, reject);
      });

      if (!Array.isArray(terms) || terms.length === 0) {
        showAlert({
          text: t("wkt.client.application.no_accepted_terms_to_show"),
          color: "info",
        });
        return;
      }

      appDialogsStore.openAcceptedTerms(terms);
    } catch (_) {
      showAlert({
        text: t("wkt.client.application.no_accepted_terms_to_show"),
        color: "error",
      });
    }
  }

  return {
    confirmLogout,
    openAcceptedTermsDialog,
    openFeatureMessagesDialog,
    openIncidenceDialog,
    openLogoutDialog,
  };
}
